import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';

import { Subnav } from '../subnav';

import PaymentForm from './PaymentForm';
import stripe_api from '../../api/stripe';

export const PaymentPage = () => {
  return (
    <main className="page">
      <div className="page__subnav">
        <Subnav isPayer={true} />
      </div>
      <div className="mainpage">
        <div className="mainpage__content">
          <div>
            <h2>Update Payment Info</h2>
            <StripeProvider apiKey={stripe_api.API_KEY}>
              <Elements>
                <PaymentForm />
              </Elements>
            </StripeProvider>
          </div>
        </div>
      </div>
    </main>
  );
};



// WEBPACK FOOTER //
// ./src/components/payment/PaymentPage.js